export const ADD_TO_CART_REQUEST = 'SHOP/ADD_TO_CART_REQUEST';
export const ADD_TO_CART_SUCCESS = 'SHOP/ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_FAILURE = 'SHOP/ADD_TO_CART_FAILURE';

export const REMOVE_FROM_CART_REQUEST = 'SHOP/REMOVE_FROM_CART_REQUEST';
export const REMOVE_FROM_CART_SUCCESS = 'SHOP/REMOVE_FROM_CART_SUCCESS';
export const REMOVE_FROM_CART_FAILURE = 'SHOP/REMOVE_FROM_CART_FAILURE';

export const UPDATE_QUANTITY_REQUEST = 'SHOP/UPDATE_QUANTITY_REQUEST';
export const UPDATE_QUANTITY_SUCCESS = 'SHOP/UPDATE_QUANTITY_SUCCESS';
export const UPDATE_QUANTITY_FAILURE = 'SHOP/UPDATE_QUANTITY_FAILURE';

export const FETCH_CART_REQUEST = 'SHOP/FETCH_CART_REQUEST';
export const FETCH_CART_SUCCESS = 'SHOP/FETCH_CART_SUCCESS';
export const FETCH_CART_FAILURE = 'SHOP/FETCH_CART_FAILURE';
export const FETCH_CART_COUNT_REQUEST = 'SHOP/FETCH_CART_COUNT_REQUEST';
export const FETCH_CART_COUNT_SUCCESS = 'SHOP/FETCH_CART_COUNT_SUCCESS';

export const CLEAR_CART_REQUEST = 'SHOP/CLEAR_CART_REQUEST';
export const CLEAR_CART_SUCCESS = 'SHOP/CLEAR_CART_SUCCESS';
export const CLEAR_CART_FAILURE = 'SHOP/CLEAR_CART_FAILURE';
export const CLEAR_CART = 'SHOP/CLEAR_CART'; // Legacy

export const PLACE_ORDER = 'SHOP/PLACE_ORDER'; // Legacy

// Order Actions
export const PLACE_ORDER_NOW_REQUEST = 'SHOP/PLACE_ORDER_NOW_REQUEST';
export const PLACE_ORDER_CART_REQUEST = 'SHOP/PLACE_ORDER_CART_REQUEST';
export const PLACE_ORDER_SUCCESS = 'SHOP/PLACE_ORDER_SUCCESS';
export const PLACE_ORDER_FAILURE = 'SHOP/PLACE_ORDER_FAILURE';

export const FETCH_ORDER_REQUEST = 'SHOP/FETCH_ORDER_REQUEST';
export const FETCH_ORDER_SUCCESS = 'SHOP/FETCH_ORDER_SUCCESS';
export const FETCH_ORDER_FAILURE = 'SHOP/FETCH_ORDER_FAILURE';

export const FETCH_ORDERS_LIST_REQUEST = 'SHOP/FETCH_ORDERS_LIST_REQUEST';
export const FETCH_ORDERS_LIST_SUCCESS = 'SHOP/FETCH_ORDERS_LIST_SUCCESS';
export const FETCH_ORDERS_LIST_FAILURE = 'SHOP/FETCH_ORDERS_LIST_FAILURE';
